import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'pp-scrollable-shadow',
  imports: [CommonModule],
  templateUrl: './scrollable-shadow.component.html',
  styleUrl: './scrollable-shadow.component.scss',
})
export class ScrollableShadowComponent {
  protected readonly Math = Math;
}
